var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnabled)?_c('v-list-item',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("\n      fal fa-fw fa-box-ballot\n    ")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }